
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Update, GetById } from "adminApi/VehicleListApi/VehicleList.js";
import { validateForm } from "utils/validation";
import { VehicleListRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditVehicleTypeForm from "./components/EditVehicleTypeForm";
import fields from "../json/VehicleTypeFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditVehicleType = () => {
    const navigate = useNavigate();
    const { formdata } = fields;
    const { id } = useParams();

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setErrors, setValues } = useFormChange(
        initialValues,
        VehicleListRules
    );

    // Fetch existing data by ID
    const { loading: loadingFetch } = useFetchFormDataById(
        id,
        formdata,
        GetById,
        setValues
    );

    // Form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await Update({ id, data: formValues });
        },
        (vals) => {
            const err = validateForm(vals, VehicleListRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Vehicle type updated successfully"
    );

    return (
        <>
            {(loadingSubmit || loadingFetch) && <Spinner isSpinner={true} />}
            <EditVehicleTypeForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Vehicle Type"
            />
        </>
    );
};

export default EditVehicleType;
